module.exports = __webpack_public_path__ + "static/media/logo.7d9c79ef.svg";